<template>
  <div id="mapS" style="height: 260px; width: 100%; margin:auto"></div>
</template>

<script>
import L from 'leaflet';

export default {
  mounted() {
    setTimeout(() => {
      this.map = L.map('mapS').setView([-12.110514254056367, -77.01841822683726], 16);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        maxZoom: 20,
      }).addTo(this.map);

      const myIcon = L.icon({
      // eslint-disable-next-line global-require
        iconUrl: require('../../../assets/marker.png'),
        iconSize: [18, 18],
      });

      const markers = [
        { latitud: -12.110514254056367, longitud: -77.01841822683726, nombre: 'Surquillo' },
      ];

      markers.forEach((markerData) => {
        const marker = L.marker([markerData.latitud, markerData.longitud], { icon: myIcon })
          .addTo(this.map);
        marker.bindPopup(markerData.nombre);
      });
    }, 2000);
  },
};
</script>

<style>
#map {
  height: 100%;
  width: 100%;
}
</style>
